module.exports = __webpack_public_path__ + "img/200-Winter-Caroline.5786b457.jpg";